/* eslint-disable no-undef */
/* eslint-disable no-continue */
/* eslint-disable no-useless-escape */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-rest-params */
/* eslint-disable consistent-return */
/* eslint-disable prefer-const */
/* eslint-disable no-unused-expressions */
/* eslint-disable eqeqeq */
/* eslint-disable func-names */
/* eslint-disable no-multi-assign */
/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
// Import dependencies
import initialiser from '../../utils/initialiser';

const defaultSettings = {
  activeClass: 'is-active',
};

class Newsletter {
  constructor(config) {
    const { el, settings } = config;

    // Set root element
    this.container = el;

    // Set settings
    this.settings = { ...defaultSettings, ...settings };
  }

  // Initialisation Function - Called on each component instance intialisation
  init = () => {
    if (!this.container) return;

    // Call bind events
    this.bindEvents();
  };

  bindEvents = () => {
    window.addEventListener('load', () => this.handleNewsletter());
  };

  handleNewsletter = () => {
    window.cfields = [];
    window._show_thank_you = function (id, message, trackcmp_url, email) {
      let form = document.getElementById(`_form_${id}_`);
      let thank_you = form.querySelector('._form-thank-you');
      form.querySelector('._form-content').style.display = 'none';
      thank_you.style.display = 'block';
      const vgoAlias = typeof visitorGlobalObjectAlias === 'undefined' ? 'vgo' : visitorGlobalObjectAlias;
      let visitorObject = window[vgoAlias];
      if (email && typeof visitorObject !== 'undefined') {
        visitorObject('setEmail', email);
        visitorObject('update');
      } else if (typeof (trackcmp_url) != 'undefined' && trackcmp_url) {
        // Site tracking URL to use after inline form submission.
        _load_script(trackcmp_url);
      }
      if (typeof window._form_callback !== 'undefined') window._form_callback(id);
    };
    window._show_error = function (id, message, html) {
      let form = document.getElementById(`_form_${id}_`);
      let err = document.createElement('div');
      let button = form.querySelector('button');
      let old_error = form.querySelector('._form_error');
      if (old_error) old_error.parentNode.removeChild(old_error);
      err.innerHTML = message;
      err.className = '_error-inner _form_error _no_arrow';
      let wrapper = document.createElement('div');
      wrapper.className = '_form-inner';
      wrapper.appendChild(err);
      button.parentNode.insertBefore(wrapper, button);
      let submitButton = form.querySelector('[id^="_form"][id$="_submit"]');
      submitButton.disabled = false;
      submitButton.classList.remove('processing');
      if (html) {
        let div = document.createElement('div');
        div.className = '_error-html';
        div.innerHTML = html;
        err.appendChild(div);
      }
    };
    window._load_script = function (url, callback, isSubmit) {
      let head = document.querySelector('head');
      let script = document.createElement('script');
      let r = false;
      let submitButton = document.querySelector('#_form_78_submit');
      script.charset = 'utf-8';
      script.src = url;
      if (callback) {
        script.onload = script.onreadystatechange = function () {
          if (!r && (!this.readyState || this.readyState === 'complete')) {
            r = true;
            callback();
          }
        };
      }
      script.onerror = function () {
        if (isSubmit) {
          if (script.src.length > 10000) {
            _show_error('78', 'Sorry, your submission failed. Please shorten your responses and try again.');
          } else {
            _show_error('78', 'Sorry, your submission failed. Please try again.');
          }
          submitButton.disabled = false;
          submitButton.classList.remove('processing');
        }
      };

      head.appendChild(script);
    };
    (function () {
      if (window.location.search.search('excludeform') !== -1) return false;
      let addEvent = function (element, event, func) {
        if (element.addEventListener) {
          element.addEventListener(event, func);
        } else {
          let oldFunc = element[`on${event}`];
          element[`on${event}`] = function () {
            oldFunc.apply(this, arguments);
            func.apply(this, arguments);
          };
        }
      };
      let _removed = false;
      let form_to_submit = document.getElementById('_form_78_');
      let allInputs = form_to_submit.querySelectorAll('input, select, textarea');
      let tooltips = [];
      let submitted = false;

      let getUrlParam = function (name) {
        if (name.toLowerCase() !== 'email') {
          let params = new URLSearchParams(window.location.search);
          return params.get(name) || false;
        }
        // email is a special case because a plus is valid in the email address
        let qString = window.location.search;
        if (!qString) {
          return false;
        }
        let parameters = qString.substr(1).split('&');
        for (let i = 0; i < parameters.length; i++) {
          let parameter = parameters[i].split('=');
          if (parameter[0].toLowerCase() === 'email') {
            return parameter[1] === undefined ? true : decodeURIComponent(parameter[1]);
          }
        }
        return false;
      };

      for (let i = 0; i < allInputs.length; i++) {
        let regexStr = 'field\\[(\\d+)\\]';
        let results = new RegExp(regexStr).exec(allInputs[i].name);

        if (results !== null) {
          allInputs[i].dataset.name = allInputs[i].name.match(/\[time\]$/)
            ? `${window.cfields[results[1]]}_time`
            : window.cfields[results[1]];
        } else {
          allInputs[i].dataset.name = allInputs[i].name;
        }
        let fieldVal = getUrlParam(allInputs[i].dataset.name);

        if (fieldVal) {
          if (allInputs[i].dataset.autofill === 'false') {
            continue;
          }
          if (allInputs[i].type === 'radio' || allInputs[i].type === 'checkbox') {
            if (allInputs[i].value === fieldVal) {
              allInputs[i].checked = true;
            }
          } else {
            allInputs[i].value = fieldVal;
          }
        }
      }

      let remove_tooltips = function () {
        for (let i = 0; i < tooltips.length; i++) {
          tooltips[i].tip.parentNode.removeChild(tooltips[i].tip);
        }
        tooltips = [];
      };
      let remove_tooltip = function (elem) {
        for (let i = 0; i < tooltips.length; i++) {
          if (tooltips[i].elem === elem) {
            tooltips[i].tip.parentNode.removeChild(tooltips[i].tip);
            tooltips.splice(i, 1);
            return;
          }
        }
      };
      let create_tooltip = function (elem, text) {
        let tooltip = document.createElement('div');
        let arrow = document.createElement('div');
        let inner = document.createElement('div'); let
          new_tooltip = {};
        if (elem.type !== 'radio' && elem.type !== 'checkbox') {
          tooltip.className = '_error';
          arrow.className = '_error-arrow';
          inner.className = '_error-inner';
          inner.innerHTML = text;
          tooltip.appendChild(arrow);
          tooltip.appendChild(inner);
          elem.parentNode.appendChild(tooltip);
        } else {
          tooltip.className = '_error-inner _no_arrow';
          tooltip.innerHTML = text;
          elem.parentNode.insertBefore(tooltip, elem);
          new_tooltip.no_arrow = true;
        }
        new_tooltip.tip = tooltip;
        new_tooltip.elem = elem;
        tooltips.push(new_tooltip);
        return new_tooltip;
      };
      let resize_tooltip = function (tooltip) {
        let rect = tooltip.elem.getBoundingClientRect();
        let doc = document.documentElement;
        let scrollPosition = rect.top - ((window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0));
        if (scrollPosition < 40) {
          tooltip.tip.className = `${tooltip.tip.className.replace(/ ?(_above|_below) ?/g, '')} _below`;
        } else {
          tooltip.tip.className = `${tooltip.tip.className.replace(/ ?(_above|_below) ?/g, '')} _above`;
        }
      };
      let resize_tooltips = function () {
        if (_removed) return;
        for (let i = 0; i < tooltips.length; i++) {
          if (!tooltips[i].no_arrow) resize_tooltip(tooltips[i]);
        }
      };
      let validate_field = function (elem, remove) {
        let tooltip = null; let { value } = elem; let
          no_error = true;
        remove ? remove_tooltip(elem) : false;
        if (elem.type !== 'checkbox') elem.className = elem.className.replace(/ ?_has_error ?/g, '');
        if (elem.getAttribute('required') !== null) {
          if (elem.type === 'radio' || (elem.type === 'checkbox' && /any/.test(elem.className))) {
            let elems = form_to_submit.elements[elem.name];
            if (!(elems instanceof NodeList || elems instanceof HTMLCollection) || elems.length <= 1) {
              no_error = elem.checked;
            } else {
              no_error = false;
              for (let i = 0; i < elems.length; i++) {
                if (elems[i].checked) no_error = true;
              }
            }
            if (!no_error) {
              tooltip = create_tooltip(elem, 'Please select an option.');
            }
          } else if (elem.type === 'checkbox') {
            let elems = form_to_submit.elements[elem.name]; let found = false; let
              err = [];
            no_error = true;
            for (let i = 0; i < elems.length; i++) {
              if (elems[i].getAttribute('required') === null) continue;
              if (!found && elems[i] !== elem) return true;
              found = true;
              elems[i].className = elems[i].className.replace(/ ?_has_error ?/g, '');
              if (!elems[i].checked) {
                no_error = false;
                elems[i].className = `${elems[i].className} _has_error`;
                err.push('Checking %s is required'.replace('%s', elems[i].value));
              }
            }
            if (!no_error) {
              tooltip = create_tooltip(elem, err.join('<br/>'));
            }
          } else if (value === undefined || value === null || value === '') {
            elem.className = `${elem.className} _has_error`;
            no_error = false;
            tooltip = create_tooltip(elem, 'This field is required.');
          }
        }
        if (no_error && (elem.id === 'field[]' || elem.id === 'ca[11][v]')) {
          if (elem.className.includes('phone-input-error')) {
            elem.className = `${elem.className} _has_error`;
            no_error = false;
          }
        }
        if (no_error && elem.name === 'email') {
          if (!value.match(/^[\+_a-z0-9-'&=]+(\.[\+_a-z0-9-']+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/i)) {
            elem.className = `${elem.className} _has_error`;
            no_error = false;
            tooltip = create_tooltip(elem, 'Enter a valid email address.');
          }
        }
        tooltip ? resize_tooltip(tooltip) : false;
        return no_error;
      };
      let needs_validate = function (el) {
        if (el.getAttribute('required') !== null) {
          return true;
        }
        if (el.name === 'email' && el.value !== '') {
          return true;
        }

        return !!((el.id === 'field[]' || el.id === 'ca[11][v]') && el.className.includes('phone-input-error'));
      };
      let validate_form = function (e) {
        let no_error = true;
        if (!submitted) {
          submitted = true;
          for (let i = 0, len = allInputs.length; i < len; i++) {
            let input = allInputs[i];
            if (needs_validate(input)) {
              if (input.type === 'text') {
                addEvent(input, 'blur', function () {
                  this.value = this.value.trim();
                  validate_field(this, true);
                });
                addEvent(input, 'input', function () {
                  validate_field(this, true);
                });
              } else if (input.type === 'radio' || input.type === 'checkbox') {
                (function (el) {
                  let radios = form_to_submit.elements[el.name];
                  for (let y = 0; y < radios.length; y++) {
                    addEvent(radios[y], 'click', () => {
                      validate_field(el, true);
                    });
                  }
                }(input));
              } else if (input.type === 'textarea') {
                addEvent(input, 'input', function () {
                  validate_field(this, true);
                });
              }
            }
          }
        }
        remove_tooltips();
        for (let i = 0, len = allInputs.length; i < len; i++) {
          let elem = allInputs[i];
          if (needs_validate(elem)) {
            if (elem.tagName.toLowerCase() !== 'select') {
              elem.value = elem.value.trim();
            }
            validate_field(elem) ? true : no_error = false;
          }
        }
        if (!no_error && e) {
          e.preventDefault();
        }
        resize_tooltips();
        return no_error;
      };
      addEvent(window, 'resize', resize_tooltips);
      addEvent(window, 'scroll', resize_tooltips);

      window.recaptcha_callback = function () {
        // Get all recaptchas in the DOM (there may be more than one form on the page).
        let recaptchas = [...document.getElementsByClassName('g-recaptcha')];
        // eslint-disable-next-line no-restricted-syntax,guard-for-in
        for (let i = 0; i < recaptchas.length; i++) {
          // Set the recaptcha element ID, so the recaptcha can be applied to each element.
          let recaptcha_id = `recaptcha_${i}`;
          recaptchas[i].id = recaptcha_id;
          let el = document.getElementById(recaptcha_id);
          if (el != null) {
            let sitekey = el.getAttribute('data-sitekey');
            let stoken = el.getAttribute('data-stoken');
            grecaptcha.render(recaptcha_id, { sitekey, stoken });
          }
        }
      }; _load_script(
        'https://www.google.com/recaptcha/api.js?onload=recaptcha_callback&render=explicit',
      );
      // eslint-disable-next-line default-case
      let _form_serialize = function (form) { if (!form || form.nodeName !== 'FORM') { return; } let i; let j; let q = []; for (i = 0; i < form.elements.length; i++) { if (form.elements[i].name === '') { continue; } switch (form.elements[i].nodeName) { case 'INPUT': switch (form.elements[i].type) { case 'tel': q.push(`${form.elements[i].name}=${encodeURIComponent(form.elements[i].previousSibling.querySelector('div.iti__selected-dial-code').innerText)}${encodeURIComponent(' ')}${encodeURIComponent(form.elements[i].value)}`); break; case 'text': case 'number': case 'date': case 'time': case 'hidden': case 'password': case 'button': case 'reset': case 'submit': q.push(`${form.elements[i].name}=${encodeURIComponent(form.elements[i].value)}`); break; case 'checkbox': case 'radio': if (form.elements[i].checked) { q.push(`${form.elements[i].name}=${encodeURIComponent(form.elements[i].value)}`); } break; case 'file': break; } break; case 'TEXTAREA': q.push(`${form.elements[i].name}=${encodeURIComponent(form.elements[i].value)}`); break; case 'SELECT': switch (form.elements[i].type) { case 'select-one': q.push(`${form.elements[i].name}=${encodeURIComponent(form.elements[i].value)}`); break; case 'select-multiple': for (j = 0; j < form.elements[i].options.length; j++) { if (form.elements[i].options[j].selected) { q.push(`${form.elements[i].name}=${encodeURIComponent(form.elements[i].options[j].value)}`); } } break; } break; case 'BUTTON': switch (form.elements[i].type) { case 'reset': case 'submit': case 'button': q.push(`${form.elements[i].name}=${encodeURIComponent(form.elements[i].value)}`); break; } break; } } return q.join('&'); };

      const formSupportsPost = false;
      let form_submit = function (e) {
        e.preventDefault();
        if (validate_form()) {
          // use this trick to get the submit button & disable it using plain javascript
          let submitButton = e.target.querySelector('#_form_78_submit');
          submitButton.disabled = true;
          submitButton.classList.add('processing');
          let serialized = _form_serialize(
            document.getElementById('_form_78_'),
          ).replace(/%0A/g, '\\n');
          let err = form_to_submit.querySelector('._form_error');
          err ? err.parentNode.removeChild(err) : false;
          // eslint-disable-next-line no-inner-declarations
          async function submitForm() {
            let formData = new FormData();
            const searchParams = new URLSearchParams(serialized);
            searchParams.forEach((value, key) => {
              formData.append(key, value);
            });

            const response = await fetch('//sydneysymphony.prospect2.com/proc.php?jsonp=true', {
              headers: {
                Accept: 'application/json',
              },
              body: formData,
              method: 'POST',
            });
            return response.json();
          }

          if (formSupportsPost) {
            submitForm().then((data) => {
              // eslint-disable-next-line no-eval
              eval(data.js);
            });
          } else {
            _load_script(`//sydneysymphony.prospect2.com/proc.php?${serialized}&jsonp=true`, null, true);
          }
        }
        return false;
      };
      addEvent(form_to_submit, 'submit', form_submit);
    }());
  };
}

// Export component wrapped in initialiser utility
export default (settings) => initialiser(settings, Newsletter);
